import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function CustomLessonDelete({ theme, ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      tabIndex={props.tabIndex}
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g clipPath="url(#clip0_6294_13004)">
        <path
          d="M1 5.14844H19"
          stroke="#9B9B9B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5401 18.9984H4.46008L3.08008 5.14844H16.9201L15.5401 18.9984Z"
          stroke="#9B9B9B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5401 1H13.4601C13.8401 1 14.1501 1.31 14.1501 1.69V5.15H5.8501V1.69C5.8501 1.31 6.1601 1 6.5401 1Z"
          stroke="#9B9B9B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58008 8.62109L8.27008 15.5411"
          stroke="#9B9B9B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.42 8.62109L11.73 15.5411"
          stroke="#9B9B9B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6294_13004">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

CustomLessonDelete.propTypes = {
  ariaTags: PropTypes.object.isRequired,
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
